import { NodePoly } from "./NodePoly";

export class QPolySet {
  constructor() {
    this.fPolyList = null;
    this.fID = -1;
    this.fColor = [0, 0, 0, 0.2];
  }

  SetID(id) {
    this.fID = id;
  }

  /**
   * @return {number}
   */
  GetID() {
    return this.fID;
  }

  SetColor(color) {
    this.fColor = color;
  }

  GetColor() {
    return this.fColor;
  }

  /**
   * @return {number}
   */
  GetNumPolys() {
    var numPolys = 0;

    if (this.fPolyList) {
      numPolys = this.fPolyList.length;
    }

    return numPolys;
  }

  GetPoly(i) {
    var poly = null;
    if (this.fPolyList && i >= 0 && i < this.fPolyList.length) {
      poly = this.fPolyList[i];
    }

    return poly;
  }

  AddPolyFromBox(box) {
    if (!this.fPolyList) {
      this.fPolyList = [];
    }

    var p = new NodePoly();
    var polyName = "undef";
    p.InitNodePolyFromBox(box, polyName, this.fColor);
    this.fPolyList.push(p);
  }

  MergePolys() {
    var mergeDone = false;

    if (!this.fPolyList || this.fPolyList.length < 2) {
      return mergeDone;
    }

    var polyDumb = new NodePoly();
    var polyObject = new Object();
    polyObject.poly = new NodePoly();

    for (var i = 0; i < this.fPolyList.length - 1; i++) {
      var poly1 = this.fPolyList[i];
      for (var j = i + 1; j < this.fPolyList.length; j++) {
        var poly2 = this.fPolyList[j];
        var mergeResult = polyDumb.MergeFar(polyObject, poly1, poly2, 40);
        if (mergeResult) {
          // the two polys can be merged. Need to replace the list
          this.fPolyList.splice(i, 1, polyObject.poly);
          this.fPolyList.splice(j, 1);
          poly1 = this.fPolyList[i];
          j = i; // for loop makes it i + 1
          mergeDone = mergeResult;
        }
      }
    }

    if (mergeDone) {
      this.MergePolys();
    }

    return mergeDone;
  }

  Log(logMessagePrefix) {
    console.log(logMessagePrefix);
    console.log("Group: " + this.fID + ", Num polys:" + this.GetNumPolys());

    for (var i = 0; i < this.GetNumPolys(); i++) {
      var p = this.GetPoly(i);
      var msg = "   " + i.toString();
      p.log(msg);
    }
  }
}
